import { http } from '@/http/axios.js'
// 地址树
export function getAdminUserTreeAPI() {
    return http({
        url: '/api/admin/rbac/adminUser/tree',
        method: 'GET',
    })
}
